export default "__VITE_ASSET__Ek_0Wn_Y__"